import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { TripInspectionEntity } from './trip-inspection.entity';

export type TripInspectionPhotoType =
	| 'front_left'
	| 'front_right'
	| 'rear_left'
	| 'rear_right'
	| 'inventory'
	| 'damage';

@Entity('trip_inspection_photo')
@Index('idx_trip_inspection_photo_inspection', ['tripInspectionId'])
@Index('idx_trip_inspection_photo_file', ['fileId'])
export class TripInspectionPhotoEntity extends BaseEntity {
	@Column({ name: 'fk_trip_inspection__id', type: 'int', unsigned: true })
	public tripInspectionId!: number;

	@Column({
		name: 'fk_file__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public fileId?: number | null;

	@Column({ name: 'image_url', type: 'varchar', length: 255, nullable: true })
	public imageUrl?: string | null;

	@Column({
		name: 'thumbnail_url',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public thumbnailUrl?: string | null;

	@Column({ name: 'photo_type', type: 'varchar', length: 50 })
	public photoType!: TripInspectionPhotoType;

	@Column({ name: 'notes', type: 'text', nullable: true })
	public notes?: string | null;

	@Column({ name: 'taken_at', type: 'datetime' })
	public takenAt!: Date;

	@Column({
		name: 'sort_order',
		type: 'int',
		unsigned: true,
		default: 0,
	})
	public sortOrder!: number;

	@ManyToOne(
		() => TripInspectionEntity,
		(tripInspection) => tripInspection.photos,
	)
	@JoinColumn({ name: 'fk_trip_inspection__id' })
	public fkTripInspection?: TripInspectionEntity;

	@ManyToOne(() => FileEntity)
	@JoinColumn({ name: 'fk_file__id' })
	public fkFile?: FileEntity;
}
